import { Typography, Checkbox } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import { styled } from '@mui/material/styles';

export const useStyles = makeStyles((theme) => ({
  card: {
    border: '1px solid #D9D9D9',
    borderRadius: 10,
    margin: '25px 0px',
    alignItems: 'center',
    padding: 44,
    [theme.breakpoints.down('md')]: {
      padding: 22,
    },
    [theme.breakpoints.down('xs')]: {
      padding: 10,
      textAlign: 'center',
    },
  },
  lightBackground: {
    backgroundColor: '#F5F5F0',
  },
  description: {
    textAlign: 'left',
    paddingRight: '18%',
    [theme.breakpoints.down('md')]: {
      paddingRight: 'unset',
    },
  },
  inputGridItem: {
    display: 'flex',
    flexDirection: 'column !important', // Always stack vertically
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  errorMessage: {
    color: '#AB2B28',
    marginBottom: '10px',
  },
  fundSubtitle: {
    paddingBottom: '25px',
  },
}));

export const CardSubtitleTypography = styled(Typography)({
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '20px',
});

export const CardLabelTypography = styled(Typography)(({ theme }) => ({
  fontSize: 26,
  fontWeight: 600,
  [theme.breakpoints.down('sm')]: {
    fontSize: 20,
  },
}));

export const AllocationLableTypography = styled(Typography)({
  fontSize: 14,
  fontWeight: 400,
  '&&': {
    color: '#7B5599',
  },
});

export const StyledCheckBox = styled(Checkbox)({
  color: '#D9D9D9',
  '&.Mui-checked': {
    color: '#7b5599',
  },
});
